import Swiper from "swiper";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export const initHeroBento = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(".hero-bento__swiper");

  if (sliders.length === 0) {
    return;
  }

  sliders.forEach((sliderElement) => {
    // Check if loop is needed based on slide count
    const slideCount = sliderElement.querySelectorAll(".swiper-slide").length;
    const enableLoop = slideCount > 1;

    new Swiper(sliderElement, {
      modules: [Pagination, Autoplay, EffectFade],
      loop: enableLoop,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  });

  console.log("[Slider] Hero Bento Swiper initialized.");
};
